import { rem, rgba } from 'polished';
import styled from 'styled-components';

import ModalBoxAdapter from './ModalBoxAdapter';

export const StyledCloseButton = styled.button`
  position: absolute;
  top: ${rem('24px')};
  right: ${rem('24px')};
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${rem('24px')};
  height: ${rem('24px')};
  padding: 0;
  background-color: transparent;
  border: none;
  appearance: none;
  cursor: pointer;

  svg {
    display: block;
    width: ${rem('13px')};
    height: auto;
  }

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.l}) {
    display: none;
  }
`;

export const StyledModalBox = styled(ModalBoxAdapter)`
  position: relative;

  &__overlay {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: ${({ theme }) => theme.layers.modal};
    background-color: ${({ theme }) =>
      `${rgba(theme.colors.cross.black, 0.5)}`};
  }

  &__content {
    position: fixed;
    top: 50%;
    left: 50%;
    padding: ${({ theme }) => rem(theme.spacings.s)};
    background-color: ${({ theme }) => theme.colors.main};
    border-radius: ${({ theme }) => rem(theme.spacings.s)};
    transform: translateX(-50%) translateY(-50%);

    &:focus {
      outline: none; //TODO add proper focus style
    }

    @media screen and (max-width: ${({ theme }) => theme.breakpoints.l}) {
      width: calc(100vw - ${rem('32px')});
    }

    @media screen and (min-width: ${({ theme }) => theme.breakpoints.l}) {
      padding: ${rem('40px')};
    }
  }
`;
